<template>
  <div class="group-editor">
    <div class="grid grid-cols-6 gap-4" id="group-editor-headers">
      <div>INDICADORES</div>
      <div>INDICADOR SLUG</div>
      <div>CALIFICACIÓN INDICADOR</div>
      <div>TIPO DE ANÁLISIS</div>
      <div>LIMITE INFERIOR</div>
      <div>LIMITE SUPERIOR</div>
    </div>

    <div id="group-editor-rules-container">
      <div class="grid grid-cols-6 gap-4">
        <div>Resultado Pre-Aprobación</div>
        <div>PreApproveModelResult</div>
        <div>100 %</div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupEditorTable",
}
</script>

<style scoped>

</style>